import { EntityModel } from '@/interfaces'
import {
  ALL_GRID_BLOCKS_QUERY,
  CREATE_GRID_BLOCK_MUTATION,
  DELETE_GRID_BLOCK_MUTATION,
  FORCE_DELETE_GRID_BLOCK_MUTATION,
  SINGLE_GRID_BLOCK_QUERY,
  UPDATE_GRID_BLOCK_MUTATION,
} from './graphql'
import cmsGridBlockColumnEntity from '@/entities/cmsGridBlockColumn/entity'

const cmsGridBlockModel: EntityModel = {
  name: 'gridBlock',
  namePlural: 'gridBlocks',
  uniqueName: 'cmsGridBlock',
  uniqueNamePlural: 'cmsGridBlocks',
  path: 'cms/blocks/grid_block',
  baseUrl: '/cms/blocks/grid_blocks',
  translationPrefix: 'entities:cmsGridBlock.',
  getDisplayName: (values: any) => {
    return 'Grid Block'
  },
  gql: {
    getAll: ALL_GRID_BLOCKS_QUERY,
    getSingle: SINGLE_GRID_BLOCK_QUERY,
    create: CREATE_GRID_BLOCK_MUTATION,
    update: UPDATE_GRID_BLOCK_MUTATION,
    delete: DELETE_GRID_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_GRID_BLOCK_MUTATION,
  },
  attributes: {
    columns: {
      name: 'columns',
      label: 'entities:cmsGridBlock.attributes.columns.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return cmsGridBlockColumnEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsGridBlockModel
